import {MutationTree} from "vuex";
import {PriorityRulesState} from "@/store/rules/priority_rules/types";

export const mutations: MutationTree<PriorityRulesState> = {
  setPriorityRules:(state, payload) => {
    state.priorityRules = payload
  },
  setPriorityRuleItem:(state, payload) => {
    state.priorityRuleItem = payload
  }
}